import { REQUEST_STATUS } from './request-status.enum';
import { REQUEST_TITLE } from './request-title.enum';
import { RouterPathConfig } from './router-path.config';
import { VIEW_TYPE } from './view-type.enum';

export class RequestsTypesConstants {
    public static NEW_REQUESTS = {
        title: REQUEST_TITLE.NEW_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.NEW_REQUESTS,
        viewType: VIEW_TYPE.NEW_REQUESTS,
        status: REQUEST_STATUS.OPEN_REQUEST_STATUS,
        count: 0,
        name: 'NEW_REQUESTS',
        img: 'newRequest.svg'
    };

    public static OPERATION_OPEN_REQUESTS = {
        title: REQUEST_TITLE.NEW_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.NEW_REQUESTS,
        viewType: VIEW_TYPE.NEW_REQUESTS,
        status: REQUEST_STATUS.OPERATION_OPEN_REQUEST_STATUS,
        count: 0,
        name: 'NEW_REQUESTS',
        img: 'newRequest.svg'
    };

    public static RETURNED_REQUESTS = {
        title: REQUEST_TITLE.RETURNED_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.RETURNED_REQUESTS,
        viewType: VIEW_TYPE.RETURNED_REQUESTS,
        status: REQUEST_STATUS.RETURNED_REQUEST_STATUS,
        count: 0,
        name: 'RETURNED_REQUESTS',
        img: 'backRequest.svg'
    };

    public static ASSIGNED_TO_ME_REQUESTS = {
        title: REQUEST_TITLE.ASSIGNED_TO_ME_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.ASSIGNED_TO_ME_REQUESTS,
        viewType: VIEW_TYPE.ASSIGNED_TO_ME_REQUESTS,
        status: REQUEST_STATUS.INPROGRESS_REQUEST_STATUS,
        count: 0,
        name: 'ASSIGNED_TO_ME_REQUESTS',
        img: 'tomeRequest.svg'
    };

    public static OPERATION_ASSIGNED_TO_ME_REQUESTS = {
        title: REQUEST_TITLE.ASSIGNED_TO_ME_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.ASSIGNED_TO_ME_REQUESTS,
        viewType: VIEW_TYPE.ASSIGNED_TO_ME_REQUESTS,
        status: REQUEST_STATUS.OPERATION_INPROGRESS_REQUEST_STATUS,
        count: 0,
        name: 'ASSIGNED_TO_ME_REQUESTS',
        img: 'tomeRequest.svg'
    };

    public static INPROGRESS_REQUESTS = {
        title: REQUEST_TITLE.INPROGRESS_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.INPROGRESS_REQUESTS,
        viewType: VIEW_TYPE.INPROGRESS_REQUESTS,
        status: REQUEST_STATUS.INPROGRESS_REQUEST_STATUS,
        count: 0,
        name: 'INPROGRESS_REQUESTS',
        img: 'underRequest.svg'
    };

    public static OPERATION_INPROGRESS_REQUESTS = {
        title: REQUEST_TITLE.INPROGRESS_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.INPROGRESS_REQUESTS,
        viewType: VIEW_TYPE.INPROGRESS_REQUESTS,
        status: REQUEST_STATUS.OPERATION_INPROGRESS_REQUEST_STATUS,
        count: 0,
        name: 'INPROGRESS_REQUESTS',
        img: 'underRequest.svg'
    };

    public static SECURITY_COORDINATOR_REQUESTS = {
        title: REQUEST_TITLE.SECURITY_COORDINATOR_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.SECURITY_COORDINATOR_REQUESTS,
        viewType: VIEW_TYPE.SECURITY_COORDINATOR_REQUESTS,
        status: REQUEST_STATUS.SECURITY_COORDINATOR_REQUESTS,
        count: 0,
        name: 'SECURITY_COORDINATOR_REQUESTS',
        img: 'underRequest.svg'
    };

    public static COMPLETED_REQUESTS = {
        title: REQUEST_TITLE.COMPLETED_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.COMPLETED_REQUESTS,
        viewType: VIEW_TYPE.COMPLETED_REQUESTS,
        status: REQUEST_STATUS.CLOSED_REQUEST_STATUS,
        count: 0,
        name: 'COMPLETED_REQUESTS',
        img: 'completeRequest.svg'
    };

    public static OPERATION_COMPLETED_REQUESTS = {
        title: REQUEST_TITLE.TO_COMPLETED_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.COMPLETED_REQUESTS,
        viewType: VIEW_TYPE.COMPLETED_REQUESTS,
        status: REQUEST_STATUS.OPERATION_COMPLETED_REQUEST_STATUS,
        count: 0,
        name: 'COMPLETED_REQUESTS',
        img: 'completeRequest.svg'
    };

    public static EMPLOYEE_MANAGEMENT_REQUESTS = {
        title: REQUEST_TITLE.EMPLOYEE_MANAGEMENT_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.EMPLOYEE_MANAGEMENT_REQUESTS,
        viewType: VIEW_TYPE.EMPLOYEE_MANAGEMENT_REQUESTS,
        status: REQUEST_STATUS.EMPLOYEE_MANAGEMENT_REQUESTS,
        count: 0,
        name: 'EMPLOYEE_MANAGEMENT_REQUESTS',
        img: 'completeRequest.svg'
    };

    public static DASHBOARD = {
        title: REQUEST_TITLE.DASHBOARD,
        path: 'dashboard',
        viewType: VIEW_TYPE.DASHBOARD,
        status: undefined,
        count: undefined,
        name: 'DASHBOARD'
    };
    public static CALL_RECORD_DASHBOARD = {
        title: REQUEST_TITLE.CALL_RECORD_DASHBOARD,
        path: 'callRecordDashboard',
        viewType: VIEW_TYPE.CALL_RECORD_DASHBOARD,
        status: undefined,
        count: undefined,
        name: 'CALL_RECORD_DASHBOARD'
    };
    public static CALL_RECORD = {
        title: REQUEST_TITLE.CALL_RECORD,
        path: 'callRecord',
        viewType: VIEW_TYPE.CALL_RECORD,
        status: undefined,
        count: 0,
        name: 'CALL_RECORD'
    };
    public static COMPLETED_HISTORY_REQUESTS = {
        title: REQUEST_TITLE.COMPLETED_HISTORY_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.COMPLETED_HISTORY_REQUESTS,
        viewType: VIEW_TYPE.COMPLETED_HISTORY_REQUESTS,
        status: REQUEST_STATUS.OPERATION_COMPLETED_HISTORY_REQUESTS,
        count: 0,
        name: 'COMPLETED_HISTORY_REQUESTS',
        img: 'completedHistoryRequests.svg'
    };

    public static TECHNICAL_OPERATIONS_REQUESTS = {
        title: REQUEST_TITLE.TECHNICAL_OPERATIONS_REQUESTS,
        path: RouterPathConfig.REQUEST_PATH.TECHNICAL_OPERATIONS_REQUESTS,
        viewType: VIEW_TYPE.TECHNICAL_OPERATIONS_REQUESTS,
        status: REQUEST_STATUS.OPERATION_TECHNICAL_REQUESTS_STATUS,
        count: 0,
        name: 'TECHNICAL_OPERATIONS_REQUESTS',
        img: 'operationsRequests.svg'
    };
}
